import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';

import InventoryAdd from './inventory-add';
import InventoryEdit from './inventory-edit';
import InventoryImport from './inventory-import';
import ItemImport from './item-import';
import ConfirmationRemove from './confirmation-remove';

import queryString from 'query-string';
import emptyImages from 'assets/img/empty-images.svg';
import sortIconDown from 'assets/img/sort-amount-down-solid.svg';
import exitIcon from 'assets/img/exit.svg';
import sortIconUp from 'assets/img/sort-amount-up-solid.svg';

import InventoryServices from './services';
import './inventory.css';

const SCREEN_KEYS = {
  ListInventory: 'list-inventory',
  AddInventory: 'add-inventory',
  EditInventory: 'edit-inventory',
  ImportItem: 'import-item',
  ImportInventory: 'import-inventory'
};

class InventoryList extends Component {
  static propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.location,

    projectId: PropTypes.string,
    inventoryList: PropTypes.array
  }

  constructor(props) {
    super(props);

    this.inventoryServices = new InventoryServices(this.props.dispatch);

    this.state = {
      showRemoveDialog: false,
      selectedItem: null,
      sortNameAZ: true,

      currentImportingStep: 0,
      selectedInventories: [],
      disableNext: 'true',
      disableDone: '',

      activeSreen: SCREEN_KEYS.ListInventory
    };
  }

  componentDidMount() {
    this.inventoryServices.getInventoryList(this.props.projectId);
  }

  // helpers
  compareData = (a, b) => {
    const lowerA = a.name.toLowerCase();
    const lowerB = b.name.toLowerCase();

    if (this.state.sortNameAZ) {
      return lowerA.localeCompare(lowerB);
    }

    return lowerB.localeCompare(lowerA);
  }
  // end helpers

  // user events
  onClickSortIcon = () => {
    this.setState({
      sortNameAZ: !this.state.sortNameAZ
    });
  }

  onClickNewButton = () => {
    this.setState({
      activeSreen: SCREEN_KEYS.AddInventory
    });
  }

  onClickImportButton = (e) => {
    e.preventDefault();

    this.setState({
      currentImportingStep: 1,
      activeSreen: SCREEN_KEYS.ImportInventory
    });
  }

  onClickInventory = (id) => {
    this.setState({
      selectedInventoryId: id,
      activeSreen: SCREEN_KEYS.EditInventory
    });
  }

  onClickNextImportButton= () => {
    if (this.state.currentImportingStep === 1) {
      let selected = this.importInventoryRef.state.checkedItemArray.map((value) => {
        return value[1];
      });
      this.setState({...this.state, disableNext: 'true', disableDone: 'true'}, () => {
        this.importInventoryRef.submit(() => {
          this.setState({
            ...this.state,
            activeSreen: SCREEN_KEYS.ImportItem,
            selectedInventories: selected,
            currentImportingStep: 2,
            disableNext: '',
            disableDone: ''
          });
        });
      });
    }
  }

  onClickDoneImportButton = () => {
    this.setState({
      ...this.state,
      disableNext: 'true',
      disableDone: 'true'
    },
    () => {
      this.importInventoryRef.submit(() => {
        this.setState({
          ...this.state,
          disableNext: '',
          disableDone: ''
        },
        this.goBackAndRefresh);
      });
    });
  }

  onCloseConfirmRemove = () => {
    this.hideRemoveDialog();
  }
  // end user events

  // navigators
  goBackAndRefresh = () => {
    this.setState({
      activeSreen: SCREEN_KEYS.ListInventory
    },
    () => this.inventoryServices.getInventoryList(this.props.projectId));
  }

  goToItemListByInventory = (id) => () => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);

    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        ...queryParams,
        tab: 'inventoryItem',
        inventoryId: id
      })
    });
  }

  showRemoveDialog = (item) => {
    this.setState({
      showRemoveDialog: true,
      selectedItem: item
    });
  }

  hideRemoveDialog = (callback) => {
    this.setState(
      {
        showRemoveDialog: false,
        selectedItem: null
      },
      callback
    );
  }
  // end navigators

  // services
  removeInventory = (id) => {
    this.inventoryServices.removeInventory(
      id,
      () => this.hideRemoveDialog(() => {
        this.inventoryServices.getInventoryList(this.props.projectId);
      }));
  }
  // end services

  getSubmitInImportInventory(r) {
    this.importInventoryRef = r;
  }

  hasSelectedItem = (isSelected) => {
    this.setState({
      ...this.state,
      disableNext: isSelected ? '' : 'true'
    });
  }

  // renders
  renderRemoveIcon = (item) => {
    return (
      <i className='fa fa-trash cancel-icon func-icon' onClick={() => this.showRemoveDialog(item)}
      />
    );
  };

  renderWizardBar() {
    return (
      <div className='row'>
        <div className='col-md-6 col-xs-6'>
          {
            this.state.activeSreen === SCREEN_KEYS.ImportInventory &&
            <button
              className='btn btn-primary btn-siteone'
              disabled={this.state.disableNext}
              onClick={this.onClickNextImportButton}>Next</button>
          }
        </div>
        <div className='col-md-6 col-xs-6'>
          <button
            className='btn btn-primary btn-siteone'
            disabled={this.state.disableDone}
            onClick={this.onClickDoneImportButton} style={{ float: 'right' }}>Done</button>
        </div>
      </div>
    );
  }

  renderInventoryList = () => {
    if (isEmpty(this.props.inventoryList)) {
      return (
        <div style={{ textAlign: 'center', margin: '5%' }} className='row'>
          <div className='col-12'>
            <img src='/images/empty-dashboard_bw.png' style={{ width: 485, opacity: 0.8 }} />
          </div>
          <div className='col-12'>
            <h3 style={{ fontSize: 20 }}>No inventory, yet.</h3>
            <button
              className='category-create-button btn btn-primary btn-siteone'
              onClick={this.onClickNewButton}
            >
                Create a new inventory
            </button>
            <div style={{marginTop: '10px', fontSize: '16px'}}>
              <a href='#' onClick={this.onClickImportButton}>or Import from Library</a>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (
        <React.Fragment>
          <div className='row'>
            <div className='col-xs-6'>
              <span
                onClick={this.onClickSortIcon}
                style={{ cursor: 'pointer' }}
                className='category-sort-icon'
              >
                {this.state.sortNameAZ ? <img src={sortIconUp} width={20} height={20} /> : <img src={sortIconDown} width={20} height={20} />}
              </span>
            </div>
            <div className='col-xs-6' style={{ marginBottom: 15 }}>
              <button
                style={{ float: 'right', marginLeft: 20 }}
                onClick={this.onClickNewButton}
                className='btn btn-primary btn-siteone'
              >
                <span className='fa fa-plus icon' /> NEW
              </button>
              <button
                style={{ float: 'right' }}
                className='btn btn-default btn-outline'
                onClick={this.onClickImportButton}
              >
                <span className='glyphicon glyphicon-import' /> IMPORT</button>
            </div>
          </div>
          <div className='row'>
            {
              this.props.inventoryList.sort(this.compareData).map(el => {
                return (
                  <div key={el.id} style={{ marginBottom: 15 }} className='col-md-3 col-xs-6 col-sm-6 col-lg-3'>
                    <div className='category-list-items'>
                      <div className='category-list-item-wrapper'>
                        <div className='document-thumbnail-wrapper thumbnail-wrapper-item'>
                          <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={el.thumbnail && el.thumbnail.thumbnailUrl ? el.thumbnail.thumbnailUrl : emptyImages} />
                          <div onClick={() => this.onClickInventory(el.id)} className='document-fade' />
                          {this.renderRemoveIcon(el)}
                        </div>
                      </div>
                      <div className='category-list-items-project-name' style={{marginTop: '20px'}}>
                        <div className='category-name col-md-8 col-sm-8' style={{lineHeight: '28px'}}>
                          <span>{el.name}</span>
                        </div>
                        <div className='category-name col-md-4 col-sm-4' onClick={this.goToItemListByInventory(el.id)} style={{ textAlign: 'right' }}>
                          <img src={exitIcon} width={24} height={24} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    const { showRemoveDialog } = this.state;
    const { projectId } = this.props;

    {
      return (
        <React.Fragment>
          <div className='manage-category-container container-fluid'>
            {
              this.state.activeSreen === SCREEN_KEYS.ListInventory && this.renderInventoryList()
            }

            {
              this.state.activeSreen === SCREEN_KEYS.AddInventory && <InventoryAdd
                projectId={projectId}
                goBack={this.goBackAndRefresh}
              />
            }
            {
              this.state.activeSreen === SCREEN_KEYS.EditInventory && <InventoryEdit
                projectId={projectId}
                inventoryId = {this.state.selectedInventoryId}
                goBack={this.goBackAndRefresh}
              />
            }

            {
              this.state.activeSreen === SCREEN_KEYS.ImportInventory && <InventoryImport
                projectId={projectId}
                exposeRef={child => { this.importInventoryRef = child; }}
                hasSelected={this.hasSelectedItem}
                goBack={this.goBackAndRefresh}
              />
            }

            {
              this.state.activeSreen === SCREEN_KEYS.ImportItem && <ItemImport
                projectId={projectId}
                exposeRef={child => { this.importInventoryRef = child; }}
                selectedInventories={this.state.selectedInventories}
                goBack={this.goBackAndRefresh}
              />
            }

            {
              showRemoveDialog && <ConfirmationRemove
                isOpen={showRemoveDialog}
                item={this.state.selectedItem}
                onClose={this.onCloseConfirmRemove}
                onRemove={this.removeInventory} />
            }

            {
              ([SCREEN_KEYS.ImportItem, SCREEN_KEYS.ImportInventory].includes(this.state.activeSreen)) && this.renderWizardBar()
            }

          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    inventoryList: state.ProjectStore.categoryList
  };
};
export default withRouter(connect(mapStateToProps)(InventoryList));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/inventory-list.js